import { useMutation } from 'react-query';
import useAxiosPrivate from '../hooks/useAxiosPrivate';

export const useExceptionHandler = () => {
  const axiosPrivate = useAxiosPrivate();
  return useMutation(
    'error-logs',
    (log) => {
      return axiosPrivate.post('/errorLogger', log);
    },
    { refetchOnWindowFocus: false, cacheTime: 0 },
  );
};
